import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

interface LetContext<T> {
  finLet: T;
}

@Directive({
  selector: '[finLet]',
  standalone: false,
})
export class LetDirective<T> {
  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject<TemplateRef<LetContext<T>>>(TemplateRef);

  private context: LetContext<T> = { finLet: null };

  constructor() {
    this.viewContainer.createEmbeddedView(this.templateRef, this.context);
  }

  @Input()
  set finLet(value: T) {
    this.context.finLet = value;
  }
}
